import React from "react";

type FieldProps = {
  label?: string;
  hint?: string;
  error?: string | null;
  className?: string;
  children: React.ReactNode;
};

export const Field: React.FC<FieldProps> = ({ label, hint, error, className = "", children }) => (
  <div className={className}>
    {label && <label className="field-label">{label}</label>}
    {hint && <p className="field-hint">{hint}</p>}
    {children}
    {error && <p className="field-error">{error}</p>}
  </div>
);

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  error?: string | null;
};

export const Input: React.FC<InputProps> = ({ error, className = "", ...rest }) => (
  <input
    className={`field-input ${error ? "field-input-error" : ""} ${className}`.trim()}
    {...rest}
  />
);

type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  error?: string | null;
};

export const Textarea: React.FC<TextareaProps> = ({ error, className = "", ...rest }) => (
  <textarea
    className={`field-input min-h-[5.5rem] ${error ? "field-input-error" : ""} ${className}`.trim()}
    {...rest}
  />
);
